import { Typography } from '@mui/material';
// import dayjs from 'dayjs';
import React from 'react'
// import { getCurrentDate } from '../../../utils';
import DatePicker from '../../Common/Fields/DatePickerField';
import SelectField from '../../Common/Fields/SelectField';
import TextField from '../../Common/Fields/TextField';
import { CONNECTIVITY_TYPE_OPTIONS, CUSTOMER_TYPE_OPTIONS } from '../Options/CircuitForm';

export default function OtherDetail({ formik }) {
    return (
        <div className="card">
            <div className="card-body stepFormDetails">
                <div className="row">
                    <div className='col-12'>
                        <h3 className='text-center display-6 mb-4 text-primary' style={{ 'fontSize': '22px' }}>OTHER DETAILS</h3>
                    </div>
                    <div className="col-md-6 mb-4">
                        <Typography variant='caption'>Customer Type <span className='req'>*</span></Typography>
                        <SelectField
                            name='customer_type'
                            options={CUSTOMER_TYPE_OPTIONS}
                            isSearchable={false}
                            value={CUSTOMER_TYPE_OPTIONS.filter(function (option) {
                                return option.value === formik.values.customer_type;
                            })}
                            onChange={(e) => formik.setFieldValue('customer_type', e.value)}
                        />
                    </div>
                    <div className="col-md-6 mb-4">
                        <Typography variant='caption'>Type of Connectivity <span className='req'>*</span></Typography>
                        <SelectField
                            name='type_of_connectivity'
                            options={CONNECTIVITY_TYPE_OPTIONS}
                            isSearchable={false}
                            value={CONNECTIVITY_TYPE_OPTIONS.filter(function (option) {
                                return option.value === formik.values.type_of_connectivity;
                            })}
                            onChange={(e) => formik.setFieldValue('type_of_connectivity', e.value)}
                        />
                    </div>
                    <div className="col-md-3 col-6">
                        <TextField label='Bandwidth[MB-GIG]' type="text" name='bandwidth_mb_gig' placeholder='Bandwidth[MB-GIG]' sx={{ mb: 3 }} />
                    </div>
                    <div className="col-md-3 col-6">
                        <TextField label='Mail ID' type="text" name='email' placeholder='Email' sx={{ mb: 3 }} />
                    </div>
                    <div className="col-md-3 col-6">
                        <TextField label='WAN IP' type="text" name='ip_details' placeholder='WAN IP' sx={{ mb: 3 }} />
                    </div>
                    <div className="col-md-3 col-6">
                        <TextField label='LAN IP' type="text" name='lan_ip' placeholder='LAN IP' sx={{ mb: 3 }} />
                    </div>
                    <div className="col-md-3 col-6">
                        <TextField label='LAN IP Pool' type="text" name='lan_ip_pool' placeholder='LAN IP Pool' sx={{ mb: 3 }} />
                    </div>
                    <div className="col-md-3 col-6">
                        <TextField label='Gateway' type="text" name='gateway' placeholder='Gateway' sx={{ mb: 3 }} />
                    </div>
                    <div className="col-md-3 col-6">
                        <TextField label='VLAN ID' type="text" name='vlan_id' placeholder='VLAN ID' sx={{ mb: 3 }} />
                    </div>
                    <div className="col-md-3 col-6">
                        <TextField label='DNS' type="text" name='dns' placeholder='DNS' sx={{ mb: 3 }} />
                    </div>
                    <div className="col-md-3 col-6">
                        <TextField label='IPv6' type="text" name='ipv6' placeholder='IPv6' sx={{ mb: 3 }} />
                    </div>
                    <div className="col-md-3 col-6">
                        <TextField label='Core Details' type="text" name='core_details' placeholder='Core Details' sx={{ mb: 3 }} />
                    </div>
                    <div className="col-md-3 col-6">
                        <TextField label='OSM ID' type="text" name='osm_id' placeholder='OSM ID' sx={{ mb: 3 }} />
                    </div>
                    <div className="col-md-3 col-6">
                        <TextField label='Indus ID' type="text" name='indus_id' placeholder='Indus ID' sx={{ mb: 3 }} />
                    </div>
                    <div className="col-md-3 col-6 mt-2">
                        {/* <TextField label='Link Delivery Date *' type="text" name='link_delivery_date' placeholder='YYYY-MM-DD' sx={{ mb: 3 }} /> */}
                        <DatePicker label='Link Delivery Date *' name='link_delivery_date' />
                    </div>
                    <div className="col-md-3 col-6">
                        <TextField label='Office Name *' type="text" name='office_name' placeholder='Office Name' sx={{ mb: 3 }} />
                    </div>
                    <div className="col-md-3 col-6">
                        <TextField label='Subnet Mask' type="text" name='subnet_mask' placeholder='Subnet Mask' sx={{ mb: 3 }} />
                    </div>
                    <div className="col-md-3 col-6">
                        <TextField label='IPv6 Pool' type="text" name='ipv6_pool' placeholder='IPv6 Pool' sx={{ mb: 3 }} />
                    </div>

                </div>
            </div>
        </div>

    )
}
